import { Link } from 'react-router-dom';
import { Button } from '@/components/Button';

export function NotFound() {
  return (
    <div className="auth-shell">
      <div className="auth-card">
        <h2 className="auth-card__title">Not found</h2>
        <p className="auth-card__subtitle">That route doesn't exist.</p>
        <Link to="/event-surveillance">
          <Button variant="primary" block>
            Back to leaderboard
          </Button>
        </Link>
      </div>
    </div>
  );
}
